export const actionIsNumber = (value, callback, props)=>{
    if (isNaN(value)) return;
    if(callback){
      callback({[props]: value});
    }
 }